import Platform from "@/platforms/platform";
import {baseURL} from "@/utils/url";

class PlatformApp extends Platform {

	setTitle(title) {
		let url = window.location.href;
		let source = '';
		try {
			if (window.parentProxy) {
				window.parentProxy.native.setTitleText(title);
			}
			else {

				let messageObj = {
					message: "setTitle",
					title: title,
					options: {}
				}

				window.top.postMessage(messageObj, '*')
			}
		} catch (e) {
			console.error('PlatformApp-setTitle-failed..')
		}

	}

	navigate(url) {
		/*
		 url：跳转地址
		 options 额外参数
		 replace: true/false
		 */

		//检查Url参数
		if (typeof (url) == "undefined" || url == 0) {
			return;
		}

		let targetUrl = "#iframe/" + encodeURIComponent(url);
		let messageObj = {
			message: "navigate",
			url: targetUrl,
			options: {}
		}
		window.top.postMessage(messageObj, '*')
	}

}

export default PlatformApp